var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "445", persistent: "", scrollable: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "btn",
                      attrs: { disabled: _vm.addBtnDisabled, text: "" },
                      on: { click: _vm.resetColor }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v(_vm._s(_vm.$t("New")))]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.addTemplateVisible,
        callback: function($$v) {
          _vm.addTemplateVisible = $$v
        },
        expression: "addTemplateVisible"
      }
    },
    [
      _c(
        "v-card",
        { key: _vm.addTemplateVisible, staticClass: "popup add_store_popup" },
        [
          _c("v-card-title", [
            _c("h3", { staticClass: "page-title-bar" }, [
              _c("i", { staticClass: "ico ico-template" }),
              _vm._v(_vm._s(_vm.$t("New Template Type")) + " ")
            ])
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pt-0" },
                    [
                      _c("v-text-field", {
                        staticClass: "form-input",
                        staticStyle: { "padding-top": "35px" },
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          label: _vm.$t("Type Name") + " *",
                          placeholder: "" + _vm.$t("Input the type name"),
                          clearable: ""
                        },
                        on: {
                          keypress: _vm.handleKeyUp,
                          keydown: _vm.clearTabindex
                        },
                        model: {
                          value: _vm.template.typeName,
                          callback: function($$v) {
                            _vm.$set(_vm.template, "typeName", $$v)
                          },
                          expression: "template.typeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pt-0" },
                    [
                      _c("v-select", {
                        staticClass: "form-select",
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          items: _vm.tagTypes,
                          label: _vm.$t("Template Size") + " *",
                          placeholder: "" + _vm.$t("Input the template Size")
                        },
                        on: {
                          keydown: _vm.clearTabindex,
                          change: function($event) {
                            return _vm.handleChangeColor()
                          }
                        },
                        model: {
                          value: _vm.tagType,
                          callback: function($$v) {
                            _vm.tagType = $$v
                          },
                          expression: "tagType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pt-0" },
                    [
                      _c("v-select", {
                        staticClass: "form-select",
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          items: _vm.TempColorItem,
                          label: _vm.$t("Template Color") + " *",
                          placeholder: "" + _vm.$t("Select template color")
                        },
                        on: { keydown: _vm.clearTabindex },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function(data) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "font-size": "12px" } },
                                  [
                                    data.item.length > 0
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "#000000" } },
                                          [_vm._v(_vm._s(data.item[0]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 1
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "#d1c3c3" } },
                                          [_vm._v(_vm._s(data.item[1]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 2
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[2] === "R"
                                                ? "color:red"
                                                : data.item[2] === "P"
                                                ? "color:pink"
                                                : data.item[2] === "W"
                                                ? "color:white"
                                                : "color:yellow"
                                          },
                                          [_vm._v(_vm._s(data.item[2]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 3
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[3] === "Y"
                                                ? "color:yellow"
                                                : data.item[3] === "W"
                                                ? "color:white"
                                                : "color:orange"
                                          },
                                          [_vm._v(_vm._s(data.item[3]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 4
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[4] === "O"
                                                ? "color:orange"
                                                : "color:green"
                                          },
                                          [_vm._v(_vm._s(data.item[4]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 5
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[5] === "G" &&
                                              data.item.length === 7 &&
                                              data.item[6] === "G"
                                                ? "color:#E0E0E0"
                                                : data.item[5] === "G" &&
                                                  data.item.length === 7
                                                ? "color:green"
                                                : data.item[5] === "G"
                                                ? "color:#616161"
                                                : "color:blue"
                                          },
                                          [_vm._v(_vm._s(data.item[5]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 6
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[6] === "B"
                                                ? "color:blue"
                                                : "color:#616161"
                                          },
                                          [_vm._v(_vm._s(data.item[6]))]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function(data) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "font-size": "12px" } },
                                  [
                                    data.item.length > 0
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "#000000" } },
                                          [_vm._v(_vm._s(data.item[0]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 1
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "#d1c3c3" } },
                                          [_vm._v(_vm._s(data.item[1]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 2
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[2] === "R"
                                                ? "color:red"
                                                : data.item[2] === "P"
                                                ? "color:pink"
                                                : data.item[2] === "W"
                                                ? "color:white"
                                                : "color:yellow"
                                          },
                                          [_vm._v(_vm._s(data.item[2]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 3
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[3] === "Y"
                                                ? "color:yellow"
                                                : data.item[3] === "W"
                                                ? "color:white"
                                                : "color:orange"
                                          },
                                          [_vm._v(_vm._s(data.item[3]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 4
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[4] === "O"
                                                ? "color:orange"
                                                : "color:green"
                                          },
                                          [_vm._v(_vm._s(data.item[4]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 5
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[5] === "G" &&
                                              data.item.length === 7 &&
                                              data.item[6] === "G"
                                                ? "color:#E0E0E0"
                                                : data.item[5] === "G" &&
                                                  data.item.length === 7
                                                ? "color:green"
                                                : data.item[5] === "G"
                                                ? "color:#616161"
                                                : "color:blue"
                                          },
                                          [_vm._v(_vm._s(data.item[5]))]
                                        )
                                      : _vm._e(),
                                    data.item.length > 6
                                      ? _c(
                                          "span",
                                          {
                                            style:
                                              data.item[6] === "B"
                                                ? "color:blue"
                                                : "color:#616161"
                                          },
                                          [_vm._v(_vm._s(data.item[6]))]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.tempColor,
                          callback: function($$v) {
                            _vm.tempColor = $$v
                          },
                          expression: "tempColor"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "center", "font-weight": "bold" }
                },
                [_vm._v("(OR)")]
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-0 col",
                      staticStyle: { "margin-top": "20px" }
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "form-input pr-0",
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          label: _vm.$t("Label type finder") + " *",
                          placeholder: "" + _vm.$t("Input label code"),
                          clearable: ""
                        },
                        on: {
                          keypress: _vm.handleKeyUp,
                          keydown: _vm.clearTabindex
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "searchIcon" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/btn-search.jpg"),
                                      alt: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.searchLabeltype()
                                      }
                                    }
                                  })
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.labelCode,
                          callback: function($$v) {
                            _vm.labelCode = $$v
                          },
                          expression: "labelCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pt-0 mt-0" },
                    [
                      _c("v-text-field", {
                        staticClass: "form-input mt-0 pt-0",
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          placeholder: "" + _vm.$t(_vm.placeholdertemplatetype),
                          clearable: "",
                          disabled: ""
                        },
                        on: {
                          keypress: _vm.handleKeyUp,
                          keydown: _vm.clearTabindex
                        },
                        model: {
                          value: _vm.templateType,
                          callback: function($$v) {
                            _vm.templateType = $$v
                          },
                          expression: "templateType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "d-flex justify-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: { click: _vm.addTemplate }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: { click: _vm.cancelAddTemplate }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }